import React from 'react'
import styled from 'styled-components'
import { media } from '../../../styles/utils'
import { lightGrey } from '../../../styles/colors'
import instagramIcon from '../../../assets/icons/instagram.svg'

const ContactLinksWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2rem 0;
  gap: 1.5rem;

  ${media.phone`
    flex-direction: column;
  `}
`

const InfoContainer = styled.div`
  flex: 1;
  max-width: 50%;

  ${media.phone`
    max-width: 100%;
  `}
`

const Title = styled.h2`
  font-size: 36px;
  line-height: 1.21;
  margin-bottom: 0.5rem;

  ${media.phone`
    font-size: 32px;
  `}
`

const Description = styled.p`
  font-size: 18px;
  color: ${lightGrey};
`

const LinksContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`

const CustomLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 18px;
  text-decoration: none;
  color: ${lightGrey};

  &:hover {
    text-decoration: underline;
  }
`

const PlainText = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 18px;
  color: ${lightGrey};
`

const BlockContactLinks = ({ title, description, links }) => {
  return (
    <ContactLinksWrapper>
      <InfoContainer>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
      </InfoContainer>
      <LinksContainer>
        {links &&
          links.map((link, index) => {
            const url =
              typeof link.link_url === 'string' ? link.link_url.trim() : ''

            if (url.startsWith('tel:')) {
              return (
                <PlainText key={index}>
                  {link.link_label}
                </PlainText>
              )
            }

            if (url) {
              return (
                <CustomLink
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.link_label}
                </CustomLink>
              )
            }

            return (
              <PlainText key={index}>
                {link.link_label}
              </PlainText>
            )
          })}
      </LinksContainer>
    </ContactLinksWrapper>
  )
}

export default BlockContactLinks
